<div class="modal-header">
  <h5 class="modal-title">PRINT CUTSHEET</h5>
  <span class="fa fa-close" aria-label="Close" (click)="activeModal.close()"></span>
</div>

<div class="modal-body" *ngIf="processing == 0">
  <form [formGroup]="printCutsheetForm">

    <div class="form-group">
      <label for="department">DEPARTMENT</label>
      <select formControlName="department" class="form-control" id="department" (change)="deptChange($event)">
        <option value="">SELECT DEPARTMENT</option>
        <option value="00000000-0000-0000-0000-000000000000">ALL</option>
        <option *ngFor="let department of departments" [value]="department.id">{{ department.departmentname }}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="printCutsheetForm.get('department').value == '00000000-0000-0000-0000-000000000000'">
      <label for="groupbydepartment">GROUP BY DEPARTMENT</label>
      <select formControlName="groupbydepartment" class="form-control" id="groupbydepartment">
        <option [value]="1">Yes</option>
        <option [value]="0">No</option>
      </select>
    </div>

    <div class="form-group">
      <label for="catcode">CAT CODE</label>
      <ng-select placeholder="SELECT CAT CODE" formControlName="catcode" [multiple]="true" [items]="acquisitionCodes"
        [bindLabel]="'catcode'" [closeOnSelect]="false" [(ngModel)]="selectedAcquisitionCodes" class="custom-ng-select">
        <ng-template ng-header-tmp>
          <label>
            <input type="checkbox" (change)="toggleSelectAll('CC', $event)" [checked]="isAllSelected('CC')" />
            Select All
          </label>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label"> {{item.catcode}}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-optgroup-tmp let-item="item">
          <div class="custom-group">
            <strong> {{ item.catcode }}</strong>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <label (change)="onCheckboxChange('CC',item, $event)">
            <input type="checkbox" [checked]="isSelected('CC', item)" />
            {{ item.catcode }}
          </label>
        </ng-template>
      </ng-select>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="excludeprice">EXCLUDE PRICE</label>
          <select formControlName="excludeprice" class="form-control" id="excludeprice">
            <option [value]="true">No</option>
            <option [value]="false">Yes</option>
          </select>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <label for="mtr">MTR</label>
          <select formControlName="mtr" class="form-control" id="mtr">
            <option value="1">All</option>
            <option value="2">With MTR</option>
            <option value="3">Without MTR</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Conditional Room Field -->
    <div class="form-group add-jsn-room" [ngClass]="{'d-none': true}">
      <label>ROOM NUMBER</label>
      <select formControlName="room" class="form-control" id="exampleFormControlSelect1">
        <option value="0">Select Room</option>
        <option value="">ALL</option>
        <option *ngFor="let room of rooms" [value]="room.id">
          {{ room.name }}
        </option>
      </select>
    </div>

    <div class="form-group add-jsn-room" *ngIf="!(printCutsheetForm.get('department').value === '00000000-0000-0000-0000-000000000000' && printCutsheetForm.get('groupbydepartment').value == 1)">
      <label>JSN<span class="required-text">*</span></label>
      <ng-select [className]="'jsn-select'" placeholder="SELECT JSN" formControlName="jsn" [multiple]="true"
        [items]="JSNs" [bindLabel]="'jsnlabel'" [closeOnSelect]="false" [(ngModel)]="selectedJSN"
        class="custom-ng-select">
        <ng-template ng-header-tmp>
          <label>
            <input type="checkbox" (change)="toggleSelectAll('JSN', $event)" [checked]="isAllSelected('JSN')" />
            Select All
          </label>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label"> {{item.jsnlabel}}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-optgroup-tmp let-item="item">
          <div class="custom-group">
            <strong> {{ item.jsnlabelNomenclature }}</strong>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <label (change)="onCheckboxChange('JSN',item, $event)">
            <input type="checkbox" [checked]="isSelected('JSN', item)" />
            {{ item.jsnlabelNomenclature }}
          </label>
        </ng-template>
      </ng-select>
      <p class="error text-danger mt-2" *ngIf="printCutsheetForm.get('jsn').getError('required') && submitted">Please
        select jsn </p>
    </div>

  </form>
</div>
<div class="modal-body" *ngIf="processing != 0">
  <div class="percentage">{{progressbar.width}}</div>
  <div *ngIf="processing == 1" class="progress mt-2">
    <div class="progress-bar progress-bar-striped progress-bar-animated" [ngStyle]="progressbar"></div>
  </div>
  <p class="message mt-2">
    {{processing == 1 ? 'Please wait while cutsheet is downloading...' : (processing == 2 ? 'Your file has been
    downloaded' : '') }}
  </p>
</div>

<div class="modal-footer">
  <button type="button" *ngIf="processing == 0" class="btn btn-primary" (click)="print()">Print</button>
  <button type="button" class="btn btn-default" (click)="activeModal.close()">{{processing == 2 ? 'Close' :
    'Cancel'}}</button>
</div>